import React from 'react'
import ApplicationSettings from '../Application/ApplicationSettings';

export default function DeploySettings() {
    return <ApplicationSettings settings_key="deploy" />
}
